import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/switchMap';
import {
	type CardsBulkOperationsSuccessAction,
	CARDS_BULK_OPERATIONS_SUCCESS,
} from '../../state/actions/cards/bulk-operations/index.tsx';
import {
	CARDS_FLAG_WITH_COMMENT_SUCCESS,
	type CardsFlagWithCommentSuccessAction,
} from '../../state/actions/cards/flag-with-comment/index.tsx';
import {
	CARDS_MOVE_SUCCESS,
	type CardsMoveSuccessAction,
} from '../../state/actions/cards/move/index.tsx';
import {
	CARDS_PARENT_SET_SUCCESS,
	type CardsParentSetSuccessAction,
} from '../../state/actions/cards/parent/index.tsx';
import { updateDetailView } from '../../state/actions/detail-view/index.tsx';
import { CARD_STATUS_SET, type CardStatusSetAction } from '../../state/actions/status/index.tsx';
import {
	getDetailViewData,
	partialCardsFromCardIdsSelector,
} from '../../state/selectors/cards/index.tsx';
import type { ActionsObservable, MiddlewareAPI } from '../../state/types.tsx';

export const detailViewUpdateEpic = (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$
		.ofType(
			CARDS_FLAG_WITH_COMMENT_SUCCESS,
			CARDS_PARENT_SET_SUCCESS,
			CARDS_MOVE_SUCCESS,
			CARD_STATUS_SET,
			CARDS_BULK_OPERATIONS_SUCCESS,
		)
		.switchMap(
			(
				action:
					| CardsFlagWithCommentSuccessAction
					| CardsParentSetSuccessAction
					| CardsMoveSuccessAction
					| CardStatusSetAction
					| CardsBulkOperationsSuccessAction,
			) => {
				const state = store.getState();
				const { cardId } = getDetailViewData(state) || {};

				if (!cardId) {
					return Observable.empty<never>();
				}

				if (action.type === CARDS_BULK_OPERATIONS_SUCCESS) {
					if (action.payload.includes(cardId)) {
						return Observable.of(updateDetailView());
					}
				}

				if (
					action.type === CARDS_FLAG_WITH_COMMENT_SUCCESS &&
					action.payload.cards.includes(cardId)
				) {
					return Observable.of(updateDetailView());
				}

				if (
					action.type === CARDS_PARENT_SET_SUCCESS &&
					action.payload.cards.map((card) => card.id).includes(cardId)
				) {
					return Observable.of(updateDetailView());
				}

				if (action.type === CARDS_MOVE_SUCCESS) {
					const parentIds = partialCardsFromCardIdsSelector(state)(action.payload.cardIds).map(
						(card) => card.parentId,
					);

					if (action.payload.cardIds.includes(cardId) || parentIds.includes(cardId)) {
						return Observable.of(updateDetailView());
					}
				}

				return Observable.empty<never>();
			},
		);
